<template>
    <div class="loading_contain">
        <span class="font_ani" v-for="(item, i) in font" :key="i">{{ item }}</span>
    </div>
</template>
<script>
export default {
    data() {
        return {
            font: ['课','堂','即','将','开','启','...',]
        }
    },
    mounted(){
        this.font.forEach((item, i) => {
            setTimeout(() => {
                let dom = document.querySelectorAll('.font_ani')
                if (dom[i]) {
                    dom[i].style.visibility = 'visible'
                    dom[i].style.opacity = 1
                }
            }, i * 1000)
        })
    },
    methods:{
    },
}
</script>
<style lang="scss" scoped>
.loading_contain{
    width: 100% !important;
    height: 100%;
    background: url(../../assets/img/loading_large_screen.gif) left top;
    background-size: cover;
    font-size: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    >span {
        visibility: hidden;
        opacity: 0;
        margin-right: 200px;
        transition: all 3s;
        color: #FFF;
    }
}
</style>
